import { useQuery } from 'react-query';
import { fetcher, logger } from '../utils/Fetcher';
import { API_URLS } from '../utils/urls';

export type SpeakerSessionResponse = {
  data: {
    body: string;
    createdAt: Date;
    hasSchedule: boolean;
    data: {
      affiliation: string;
      sessionLocation: string;
      sessionSchedule: string;
      speakerName: string;
      trackName: string;
    };
    id: number;
    slug: string;
    subType: string;
    title: string;
    url: string;
    type: string;
  };
  ok: boolean;
};

const useSpeakerSessionDetail = (id: number) => {
  return useQuery('sessionPage', async () => {
    try {
      const response = await fetcher.get<SpeakerSessionResponse>(
        API_URLS.SPEAKER_SESSION_DETAIL(id)
      );

      return response;
    } catch (error) {
      logger.error(error);
      throw error;
    }
  });
};

export default useSpeakerSessionDetail;
